import { STATUS_COLORS } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const StatusBadge = ({ status }) => (
  <span className="inline-flex items-center gap-1.5 text-[11px] font-mono2 tracking-wide px-2.5 py-1 rounded-full border"
    style={{ color: STATUS_COLORS[status] || "#94A3B8", borderColor: (STATUS_COLORS[status] || "#94A3B8") + "55", background: (STATUS_COLORS[status] || "#94A3B8") + "18" }}>
    <span className="h-1.5 w-1.5 rounded-full" style={{ background: STATUS_COLORS[status] || "#94A3B8" }} />
    {status}
  </span>
);

export const Panel = ({ title, action, children, testid }) => (
  <div className="rounded-2xl border border-white/10 bg-[#12141C] p-5 sm:p-6" data-testid={testid}>
    {(title || action) && (
      <div className="flex items-center justify-between mb-5">
        {title && <h3 className="font-display font-bold text-white text-lg">{title}</h3>}
        {action}
      </div>
    )}
    {children}
  </div>
);

export const AdminField = ({ label, value, onChange, type = "text", testid, placeholder }) => (
  <div>
    <Label className="text-[#94A3B8] text-xs font-mono2">{label}</Label>
    <Input type={type} value={value ?? ""} onChange={onChange} placeholder={placeholder} data-testid={testid}
      className="mt-1.5 bg-[#0b0d12] border-white/10 text-white focus-visible:ring-[#02AACF]" />
  </div>
);

export const AdminSelect = ({ label, value, onChange, options, testid }) => (
  <div>
    {label && <Label className="text-[#94A3B8] text-xs font-mono2">{label}</Label>}
    <select value={value} onChange={onChange} data-testid={testid}
      className="mt-1.5 w-full rounded-md bg-[#0b0d12] border border-white/10 text-white text-sm px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#02AACF]">
      {options.map((o) => <option key={o} value={o} className="bg-[#12141C]">{o}</option>)}
    </select>
  </div>
);

export const Empty = ({ children }) => (
  <p className="text-center text-[#64748B] py-14 font-mono2 text-sm">{children}</p>
);
